import type { Moment, unitOfTime } from 'moment';
import moment from 'moment';

export const getTimeDiffFromNow = (date: string | Moment, unit: unitOfTime.Base) => {
    const today = moment();
    const dateMoment = moment.isMoment(date) ? date : moment(date);

    return dateMoment.diff(today, unit);
};
